import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router-dom'
import ValidationService from './ValidationService';
import './PersonalInfo.scss'
import TextFormInputField from '../../input-elements/TextFormInputField';
import AltButton from '../../button/AltButton';
import ActionButton from '../../button/ActionButton';
import HrbTranslate from '../../language/HrbTranslate';
import ProvinceDropdown from '../../input-elements/ProvinceDropdown';
import PhoneNumberInput from '../../input-elements/PhoneNumberInput';
import Api from '../../../services/api/Api';
import { ApiPaths } from '../../../services/api/ApiPaths';
import { HeapEvents, trackEvent } from '../../../services/util/AnalyticsUtil';

class PersonalInfoEdit extends Component {
    constructor(props) {
        super(props);
        // let's assume our initial state is ok
        this.state = {
            action: null,
            firstName: {
                value: props.profile.firstName || '',
                isValid: true,
                validated: false,
                errorKey: null
            }, 
            lastName: {
                value: props.profile.lastName || '',
                isValid: true,
                validated: false,
                errorKey: null
            },
            email: {
                value: props.profile.email || '',
                isValid: true,
                validated: false,
                errorKey: null
            },
            userName: {
                value: props.profile.userName || '',
                isValid: true,
                validated: false,
                errorKey: null
            },
            alternateEmail: {
                value: props.profile.alternateEmail || '',
                isValid: true,
                validated: false,
                errorKey: null
            },
            phoneNumber: {
                value: props.profile.phoneNumber || '',
                isValid: true,
                validated: false,
                errorKey: null
            },
            province: {
                value: props.profile.province || '',
                isValid: true,
                validated: false
            }
        };
    }

    componentDidMount() {
        const disableUntil = localStorage.getItem('disablePersonalInfoSaveButton');
        if (disableUntil && Date.now() < parseInt(disableUntil, 10)) {
            const remainingTime = parseInt(disableUntil, 10) - Date.now();
            this.setState({ isButtonDisabled: true });

            setTimeout(() => {
                this.setState({ isButtonDisabled: false });
                localStorage.removeItem('disablePersonalInfoSaveButton');
            }, remainingTime);
        }

        var el = document.getElementById('personal-info-edit-form');
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }

    onBlur = (key) => {
        var s = this.state[key];
        if (s) {
            this.validator(key, s.value, true);
        }
    }

    onChange = (key, value) => {
        var s = this.state[key];
        if (s) {
            if (s.validated) {
                this.validator(key, value);
            } else {
                var newState = { ...this.state };
                newState[key] = { ...s, value: value }
                this.setState(newState);
            }
        }
    }

    validator = (key, value, validated) => {
        let val = Boolean(validated)
        var isValid;
        switch (key) {
            case 'lastName':
                isValid = ValidationService.validateLastName(value);
                this.setState({
                    lastName: {
                        ...this.state.lastName,
                        value: value,
                        validated: val || (this.state.lastName.validated && !isValid),
                        isValid: isValid || !value,
                        errorKey: value && !isValid ? 'profile.personal_info_edit.errors.invalid_name' : null
                    }
                });
                return isValid
            case 'firstName':
                isValid = ValidationService.isValidFirstName(value);
                this.setState({
                    firstName: {
                        ...this.state.firstName,
                        value: value,
                        validated: val || (this.state.firstName.validated && !isValid),
                        isValid: Boolean(value) && isValid,
                        errorKey: !value ? 'profile.personal_info_edit.errors.missing_field' : (!isValid ? 'profile.personal_info_edit.errors.invalid_name' : null)
                    }
                });
                return isValid;
            case 'email':
                isValid = ValidationService.isValidEmail(value, true);
                this.setState({
                    email: {
                        ...this.state.email,
                        value: value,
                        validated: val || (this.state.email.validated && !isValid),
                        isValid: Boolean(value) && isValid,
                        errorKey: !value ? 'profile.personal_info_edit.errors.missing_field' : (!isValid ? 'profile.personal_info_edit.errors.invalid_email' : null)
                    }
                });
                return isValid;
            case 'alternateEmail':
                isValid = ValidationService.isValidEmail(value, false);
                this.setState({
                    alternateEmail: {
                        ...this.state.alternateEmail,
                        value: value,
                        validated: val || (this.state.alternateEmail.validated && !isValid),
                        isValid: isValid,
                        errorKey: !isValid ? 'profile.personal_info_edit.errors.invalid_email' : null
                    }
                });
                return isValid;
            case 'phoneNumber':
                isValid = !value || ValidationService.isValidPhoneNumber(value)
                this.setState({
                    phoneNumber: {
                        ...this.state.phoneNumber,
                        value: value === '(' ? '' : value,
                        validated: val || (this.state.phoneNumber.validated && !isValid),
                        isValid: isValid,
                        errorKey: !isValid ? 'profile.personal_info_edit.errors.invalid_phone' : null
                    }
                });
                return isValid;
            default:
                break;
        }
        return true;
    }

    onCancel = () => {
        this.props.history.goBack();
    }

    createProfile = () => {
        var canSave = this.validator('firstName', this.state.firstName.value, true)
            && this.validator('lastName', this.state.lastName.value, true)
            && this.validator('email', this.state.email.value, true)
            && this.validator('alternateEmail', this.state.alternateEmail.value, true)
            && this.validator('phoneNumber', this.state.phoneNumber.value, true)

        if (canSave) {
            return {
                firstName: this.state.firstName.value,
                lastName: this.state.lastName.value,
                email: this.state.email.value,
                alternateEmail: this.state.alternateEmail.value,
                phoneNumber: this.state.phoneNumber.value,
                userName: this.state.userName.value,
                province: this.state.province.value,
                lang: this.props.lang
            }
        } else {
            return null
        }

    }

    saveChanges = () => {
        var payload = this.createProfile();
        if (!payload) {
            return;
        }

        this.setState({ action: 'saving' });
        Api.put(ApiPaths.ACCOUNT_PROFILE, payload).then(
            (response) => {
                if (response.status !== 204) {
                    // TODO: Show an error message of the appropriate type
                    this.setState({ action: null })
                } else {
                    trackEvent(HeapEvents.ACCOUNT_UPDATED);
                    this.setState({ action: 'complete' });
                    setTimeout(() => {
                        this.props.profileUpdated();
                    }, 1200);
                }
            },
            (error) => {
                if (error.response) {
                    if (error.response.status === 429) {
                        // Handle Too Many Requests error
                        const disableUntil = Date.now() + 60000;
                        localStorage.setItem('disablePersonalInfoSaveButton', disableUntil);

                        this.setState({ action: null, isButtonDisabled: true });

                        setTimeout(() => {
                            this.setState({ isButtonDisabled: false });
                            localStorage.removeItem('disablePersonalInfoSaveButton');
                        }, 60000);
                    } else if (error.response.status === 409) {
                        // Handle email conflict
                        if (this.props.profile.email !== this.state.email.value) {
                            this.setState({
                                action: null,
                                email: {
                                    ...this.state.email,
                                    value: this.state.email.value,
                                    validated: true,
                                    isValid: false,
                                    errorKey: 'profile.personal_info_edit.errors.email_in_use'
                                }
                            });
                        }

                        if (this.state.alternateEmail.value && this.props.profile.alternateEmail !== this.state.alternateEmail.value) {
                            this.setState({
                                alternateEmail: {
                                    ...this.state.alternateEmail,
                                    value: this.state.alternateEmail.value,
                                    validated: true,
                                    isValid: false,
                                    errorKey: 'profile.personal_info_edit.errors.email_in_use'
                                }
                            });
                        }
                        this.setState({ action: null });
                    } else {
                    // TODO: Need to show another error to the user
                        this.setState({
                            action: null,
                            errorCode: 500
                        });
                    }
                }
            }
        );
    }

    render() {
        var canSave = this.state.firstName.isValid && this.state.lastName.isValid && this.state.email.isValid
            && this.state.alternateEmail.isValid && this.state.phoneNumber.isValid && this.state.province.isValid
            && this.state.userName.isValid;
        return (
            <div className="hrb-profile-personal-container-edit" id='personal-info-edit-form'>
                <div className="hrb-profile-personal-container-edit">
                    <div className="hrb-profile-message-row">
                        <HrbTranslate text="profile.personal_info_edit.required_warn" />
                    </div>
                    <form autoComplete="on">
                        <div className="hrb-profile-edit-row">
                            <div className="hrb-profile-edit-item left-side">
                                <TextFormInputField 
                                    propertyName='firstName'
                                    labelKey='profile.personal_info_edit.first_name'
                                    value={this.state.firstName.value}
                                    autoComplete="given-name"
                                    onBlur={this.onBlur}
                                    onChange={this.onChange}
                                    lang={this.props.lang}
                                    errorKey={this.state.firstName.validated ? this.state.firstName.errorKey : null}
                                />
                            </div>
                            <div className="hrb-profile-edit-item right-side">
                                <TextFormInputField
                                    propertyName='lastName'
                                    labelKey='profile.personal_info_edit.last_name'
                                    value={this.state.lastName.value}
                                    autoComplete="family-name"
                                    onBlur={this.onBlur}
                                    onChange={this.onChange}
                                    lang={this.props.lang}
                                    errorKey={this.state.lastName.validated ? this.state.lastName.errorKey : null}
                                />
                            </div>
                        </div>
                        <div className="hrb-profile-edit-row">
                            <div className="hrb-profile-edit-item left-side">
                                <TextFormInputField
                                    propertyName='email'
                                    isDisabled
                                    labelKey='profile.personal_info_edit.email'
                                    value={this.state.email.value}
                                    autoComplete="email"
                                    onBlur={this.onBlur}
                                    onChange={this.onChange}
                                    lang={this.props.lang}
                                    subtextKey='profile.personal_info_edit.email_sub'
                                    errorKey={this.state.email.validated ? this.state.email.errorKey : null}
                                />
                            </div>
                            <div className="hrb-profile-edit-item right-side">
                                <TextFormInputField
                                    propertyName='userName'
                                    isDisabled
                                    labelKey='profile.personal_info_edit.username'
                                    value={this.state.userName.value}
                                    onBlur={this.onBlur}
                                    onChange={this.onChange}
                                    lang={this.props.lang}
                                    subtextKey='profile.personal_info_edit.username_sub'
                                    errorKey={this.state.userName.validated ? this.state.userName.errorKey : null}
                                />
                            </div>
                        </div>
                        <div className="hrb-profile-edit-row">
                            <div className="hrb-profile-edit-item left-side">
                                <PhoneNumberInput propertyName='phoneNumber'
                                    labelKey='profile.personal_info_edit.mobile_phone'
                                    value={this.state.phoneNumber.value}
                                    autoComplete='tel-national'
                                    onBlur={this.onBlur}
                                    onChange={this.onChange}
                                    lang={this.props.lang}
                                    subtextKey='profile.personal_info_edit.mobile_sub'
                                    errorKey={this.state.phoneNumber.validated ? this.state.phoneNumber.errorKey : null}
                                />
                            </div>
                            <div className="hrb-profile-edit-item right-side">
                                <ProvinceDropdown onChange={this.onChange} value={this.state.province.value}
                                    lang={this.props.lang} labelKey='profile.personal_info_edit.province'
                                    propertyName='province'
                                />
                            </div>
                        </div>
                    </form>
                    {this.state.isButtonDisabled ?                        
                        <div className="error-message">
                            <p className="error-message-p-settings"><HrbTranslate text="profile.personal_info.unable_to_save" /></p>
                        </div> :null
                    }
                    <div className="hrb-profile-edit-buttons">
                        <AltButton text='common.cancel' onClick={this.onCancel} />
                        <ActionButton text='common.save_changes' onClick={this.saveChanges} isDisabled={this.state.isButtonDisabled || !canSave}
                            inProgress={this.state.action === 'saving'} complete={this.state.action==='complete'}
                        />
                    </div>
                </div>
            </div>
        );
    }
};

PersonalInfoEdit.propTypes = {
    profile: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    profileUpdated: PropTypes.func.isRequired
};

export default withRouter(PersonalInfoEdit);